module.exports = __webpack_public_path__ + "img/Punjab Boards.e15625b0.png";